import type { ReactNode } from 'react';
import { cn } from '~/lib/utils';

interface StatTileProps {
  label: string;
  value: string;
  delta?: string;
  deltaPositive?: boolean;
  hint?: string;
  secondary?: string;
  trend?: ReactNode;
  className?: string;
}

export function StatTile({ label, value, delta, deltaPositive, hint, secondary, trend, className }: StatTileProps) {
  return (
    <div className={cn('rounded-xl border border-slate-200 bg-white p-4', className)}>
      <div className="text-xs font-medium uppercase tracking-wide text-slate-500">{label}</div>
      <div className="mt-1.5 flex items-end justify-between gap-2">
        <div className="text-2xl font-semibold tracking-tight text-slate-900">{value}</div>
        {trend}
      </div>
      <div className="mt-1 flex items-center gap-2 text-xs">
        {delta ? (
          <span className={cn('font-medium', deltaPositive ? 'text-[#006300]' : 'text-[#d03b3b]')}>{delta}</span>
        ) : null}
        {hint ? <span className="text-slate-400">{hint}</span> : null}
      </div>
      {secondary ? <div className="mt-1.5 border-t border-slate-100 pt-1.5 text-xs text-slate-400">{secondary}</div> : null}
    </div>
  );
}
